import { render, staticRenderFns } from "./ReservationForm.vue?vue&type=template&id=b4546824&"
import script from "./ReservationForm.vue?vue&type=script&lang=js&"
export * from "./ReservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCard,VDialog,VRow})
